//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        size: { type: String, default: '20px' },
        color: { type: String, default: '#000' },
    },
    computed: {
        viewBox: function() {
            const size = this.size.replace(/[^0-9]/gi, '')

            return `0 0 ${size} ${size}`
        },
    },
}
